import { API_INSTANCE_NO_CREDENTIALS } from '../../utils/service-http';
import { getAppLocaleAsObject } from '../../utils/app-locale';
import { front_base_url } from '../../constants';

export const getRules = (rangeName, loadDefault = false) => {
  const { lang, country } = getAppLocaleAsObject();
  const fileSuffix = `_${lang}_${country}`.toLocaleLowerCase();
  const url = `${front_base_url}/rules/${rangeName.replace(/\s/g, '')}${loadDefault ? '' : fileSuffix}.md`;
  return API_INSTANCE_NO_CREDENTIALS.get(url);
}

export const getMachineExpertTooltip = (loadDefault = false) => {
  const { lang, country } = getAppLocaleAsObject();
  const fileSuffix = `_${lang}_${country}`.toLocaleLowerCase();
  const url = `${front_base_url}/machine-expert/METooltip${loadDefault ? '' : fileSuffix}.md`;
  return API_INSTANCE_NO_CREDENTIALS.get(url);
}
